import React, { useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  Segment,
  Header,
  Accordion,
  Icon,
  Table,
  Button,
} from "semantic-ui-react";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import {
  edicionConvocatoria,
  idConvocatorias,
} from "../../../../redux/actions/convocatoriaAction";
import { useNavigate } from "react-router";
import "semantic-ui-css/semantic.min.css";
import "../old.scss";
import { saveFile } from "../../../../utils/saveFile";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import { Navegador } from "../../../../components/Administrador/NavegadorConvocatoria/Navegador";
import DocumentosService from "../../../../api/Documentos/api-documentos";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { openNotification } from "../../../../utils/Notifactions";
import { useEncrypt } from "../../../../hooks/useEncrypt";
var conteoDocumentos = 0;

const PERSONA_TIPO = {
  1: "Persona_Natural",
  2: "Persona_Jurídica",
  3: "Grupo_Conformado",
};

const procesarDocumentosConvocatoria = (todosJSON, convocatoria) => {
  const convdocsArray = convocatoria.documentos_administrativos || [];
  Object.entries(todosJSON.documentacion).forEach(([i, doc]) => {
    const convdoc = convdocsArray.find((cd) => cd && doc && doc.id === cd.id);
    if (!convdoc) return;
    if (convdoc.url_documento) todosJSON.documentacion[i].url_documento = convdoc.url_documento;
    todosJSON.data["Documentos_Seleccionados"].documentos = [
      ...todosJSON.data["Documentos_Seleccionados"].documentos,
      doc.id,
    ];
    const tipoPersonaArr = todosJSON.data[PERSONA_TIPO[convdoc.tipo_persona]];
    if (tipoPersonaArr) tipoPersonaArr.documentos = tipoPersonaArr.documentos.filter((id) => id !== doc.id);
  });
};

export const Documentos = () => {
  let initialState = {
    documentacion: {},
    data: {
      Persona_Natural: {
        id: "Persona_Natural",
        documentos: [],
      },
      Persona_Jurídica: {
        id: "Persona_Jurídica",
        documentos: [],
      },
      Grupo_Conformado: {
        id: "Grupo_Conformado",
        documentos: [],
      },
      Documentos_Seleccionados: {
        id: "Documentos_Seleccionados",
        documentos: [],
      },
    },
    orden: [
      "Persona_Natural",
      "Persona_Jurídica",
      "Grupo_Conformado",
      "Documentos_Seleccionados",
    ],
  };
  const { decrypt } = useEncrypt();

  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));

  const dispatch = useDispatch();
  React.useEffect(() => {
    cargarDocumentos();
  }, []);
  const stateInitial = {
    namepdf: "",
    pdf: "",
    openModalViewer: false,
  };
  const routes = [{ nombre: "Crear convocatoria" }];
  const [principalState, setPrincipalState] = useState(stateInitial);
  const [modalVisualizar, setModalVisualizar] = useState(false);
  const [documentos, setDocumentos] = useState(initialState);
  const [activeAccordion, setActiveAccordion] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const cargarDocumentos = async () => {
    try {
      const docAdmins = await apiMaestras.obtenerDocumentosAdminsitrativos();

      const documentacionresponse = { ...docAdmins.map((data) => ({
        id: data.id,
        descripcion_del_documento: data.documento,
        subsanable: false,
        obligatorio: false,
        url_documento: "",
        source: PERSONA_TIPO[data.tipo_participante_id],
      })) };

      let arraypersonanatural = [];
      let arraypersonajuridica = [];
      let arraygrupoconformado = [];
      docAdmins.forEach((doc) => {
        if (doc.tipo_participante_id == 1) arraypersonanatural = [...arraypersonanatural, doc.id];
        else if (doc.tipo_participante_id == 2) arraypersonajuridica = [...arraypersonajuridica, doc.id];
        else if (doc.tipo_participante_id == 3) arraygrupoconformado = [...arraygrupoconformado, doc.id];
      });

      let todosJSON = { ...documentos };
      todosJSON.data.Persona_Natural.documentos = arraypersonanatural;
      todosJSON.data.Persona_Jurídica.documentos = arraypersonajuridica;
      todosJSON.data.Grupo_Conformado.documentos = arraygrupoconformado;
      todosJSON.documentacion = documentacionresponse;
      todosJSON.data["Documentos_Seleccionados"].documentos = [];

      const { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
      if (data.documentos === null) return;
      procesarDocumentosConvocatoria(todosJSON, data);
      return setDocumentos(todosJSON);
    } catch (error) {
      return console.error(error);
    }
  };
  const handleClickAccordion = (e, Titulo) => {
    let { index } = Titulo;
    let newIndex = activeAccordion === index ? -1 : index;
    return setActiveAccordion(newIndex);
  };
  const agregarDocumentacion = (data) => {
    data.url_documento = "";
    let todosDocumentos = { ...documentos };
    todosDocumentos.data["Documentos_Seleccionados"].documentos = [
      ...todosDocumentos.data["Documentos_Seleccionados"].documentos,
      data.id,
    ];
    todosDocumentos.data[data.source].documentos = todosDocumentos.data[
      data.source
    ].documentos.filter((id) => id !== data.id);


    return setDocumentos(todosDocumentos);
  };

  const eliminarDocumento = async (data) => {
    let todosDocumentos = { ...documentos };

    todosDocumentos.data["Documentos_Seleccionados"].documentos =
      todosDocumentos.data["Documentos_Seleccionados"].documentos.filter(
        (id) => id !== data.doc.id
      );

    todosDocumentos.data[data.doc.source].documentos = [
      ...todosDocumentos.data[data.doc.source].documentos,
      data.doc.id,
    ];

    if (data.doc.url_documento != "") {
      await eliminarArchivo(data.doc);
    }

    // document.querySelector(".inputs-ref").onchange()
    return setDocumentos(todosDocumentos);
  };
  const guardardocumentacionadministrativa = async () => {
    conteoDocumentos = 0;
    grabandodocumentacionAdministrativa();
  };
  const grabandodocumentacionAdministrativa = async () => {
    let idconvocatoria = idConvocatoria;
    if (documentos.data["Documentos_Seleccionados"].documentos.length === 0) {
      return openNotification({
        titulo: "Error",
        descripcion: "Debe asociarse por lo menos un documento",
        placement: "bottomRight",
      });
    }
    let documentos_administrativos = documentos.data[
      "Documentos_Seleccionados"
    ].documentos.map((data, index) => {
      let tipo_documento_id = 0;
      let tipo = {
        Persona_Natural: 0,
        Persona_Jurídica: 1,
        Grupo_Conformado: 2,
      };

      for (let i in documentos.documentacion) {
        if (documentos.documentacion[i].id == data) {
          return {
            id: documentos.documentacion[i].id,
            idconvocatoria,
            url_documento: documentos.documentacion[i].url_documento,
            descripcion: documentos.documentacion[i].descripcion_del_documento,
            subsanable: documentos.documentacion[i].subsanable,
            obligatorio: documentos.documentacion[i].obligatorio,
            tipo_documento_id: data,
            tipo_persona: tipo[documentos.documentacion[i].source],
          };
        }
      }
    });
    setLoading(true);
    const token = localStorage.getItem('token')
    await axios.post(
      `${process.env.REACT_APP_SERVER_CONV}convocatorias/documentos_administrativos/${idconvocatoria}`,
      documentos_administrativos,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    await ObjNotificaciones.MSG_SUCCESS(
      "success",
      "Se han asociado correctamente los documentos"
    );
    setLoading(false);
    return history("/administrador/documentacionTecnica");
  };

  const backComponente = () => {
    dispatch(edicionConvocatoria(true));
    dispatch(idConvocatorias(idConvocatoria));
    return history("/administrador/cronograma");
  };

  const eliminarArchivo = async (doc) => {
    await DocumentosService.eliminarArchivo(
      doc.url_documento
    );
    let todosJSON = JSON.parse(JSON.stringify(documentos));
    let indexOfValues = 0;
    Object.values(todosJSON.documentacion).forEach(
      (data2, index) => {
        if (doc.id === data2.id) {
          indexOfValues = index;
        }
      }
    );
    todosJSON.documentacion[indexOfValues].url_documento = "";

    return setDocumentos(todosJSON);
  };
  const verDocumentacion = async (data) => {
    if (data.url_documento !== "") {
      setModalVisualizar(true);
      return setPrincipalState({
        ...principalState,
        namepdf: data.url_documento,
      });
    }
  };

  const cargarUrl = async (e, doc) => {
    if (e.target.files.length > 0) {
      const data = await saveFile(e);
      let todosJSON = JSON.parse(JSON.stringify(documentos));

      for (let i in todosJSON.documentacion) {
        if (todosJSON.documentacion[i].id === doc.id) {
          todosJSON.documentacion[i].url_documento = data.data;
        }
      }

      document.querySelector(".button_archivo").value = "";
      return setDocumentos(todosJSON);
    }
    e.target.value = "";
  };

  return (
    <div className="background-color-F7FBFF m-0 h-100">
      <div className="no-margin background-color-F7FBFF">
        <div className="background-color-101c31 no-margin no-padding-top no-padding-bottom">
          <BreadCrumbAdmin routes={routes} />
        </div>
      </div>
      <Navegador
        idconvocatorias={idConvocatoria}
        activo="Doc. administrativa"
      />
      <div
        className="container-fluid pt-3 pb-2 background-color-FFFFFF "
      >
        <Header
          as="h4"
          className="font-size-14px font-color-1B1C1D font-family-Montserrat-SemiBold"
          style={{ marginBottom: "0.5%" }}
          floated="left"
        >
          Asociar documentación administrativa
        </Header>
        <Header as="h4" floated="right" style={{ marginBottom: "0.5%" }}>
          <span className="font-color-B0B0B0 font-family-Montserrat-Thin font-size-12px">
            Código de convocatoria {idConvocatoria}
          </span>
        </Header>
      </div>

      <div className="container-fluid background-color-F7FBFF main-c3">
        <div className="row no-margin">
          <div className="col-12 col-md-4 no-padding-left no-padding-right">
            <div style={{ margin: "16px" }}>
              <div className="row">
                <div className="col-12 row-shadow-documentos-1">
                  {documentos.orden.map((doc, index) => {
                    const datos = documentos.data[doc];
                    if (datos.id === "Documentos_Seleccionados") return;
                    const documentacion = datos.documentos.map((data) => {
                      let indexOfValues = 0;
                      Object.values(
                        documentos.documentacion
                      ).forEach((data2, index) => {
                        if (data === data2.id) {
                          indexOfValues = index;
                        }
                      });
                      return documentos.documentacion[indexOfValues];
                    });
                    return (
                      <Segment
                        className="no-margin"
                        key={datos.id}
                        style={{ border: "1px solid #EAEBEC" }}
                      >
                        <Accordion>
                          <Accordion.Title
                            active={activeAccordion === index}
                            index={index}
                            onClick={handleClickAccordion}
                          >
                            <div className="no-margin">
                              <div columns={2} style={{ padding: 0 }}>
                                <div>{datos.id}</div>
                                <div className="justify-content-flex-end">
                                  <Icon name="dropdown" />
                                </div>
                              </div>
                            </div>
                          </Accordion.Title>
                          <Accordion.Content active={activeAccordion === index}>
                            <div className="listado-container-documentacion">
                              {documentacion.map((docu, index) => {
                                if (docu) {
                                  return (
                                    <div
                                      className="container-documentacion"
                                      onClick={() => agregarDocumentacion(docu)}
                                      key={docu.descripcion_del_documento}
                                    
                                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
                                    >
                                      <Icon name="hdd" />
                                      {docu.descripcion_del_documento}
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </Accordion.Content>
                        </Accordion>
                      </Segment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-8 no-padding-left no-padding-right">
            <div style={{ margin: "16px" }}>
              <div className="row">
                <div className="col-12 row-shadow-documentos">
                  {documentos.orden.map((doc, index) => {
                    const datos = documentos.data[doc];
                    if (datos.id !== "Documentos_Seleccionados") return;
                    const documentacion = datos.documentos.map((data) => {
                      let indexOfValues = 0;
                      Object.values(
                        documentos.documentacion
                      ).forEach((data2, index) => {
                        if (data === data2.id) {
                          indexOfValues = index;
                        }
                      });
                      return documentos.documentacion[indexOfValues];
                    });
                    return (
                      <Table fixed singleLine key={doc}>
                        <Table.Header className="table-thead-tbody-flex">
                          <Table.HeaderCell
                            width={5}
                            className="background-color-FFFFFF font-size-12px"
                          >
                            Documentos seleccionados
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            width={3}
                            className="background-color-FFFFFF font-size-12px"
                          >
                            Tipo
                          </Table.HeaderCell>
                          {/* <Table.HeaderCell
                            textAlign="center"
                            width={2}
                            className="background-color-FFFFFF font-size-12px"
                          >
                            ¿Subsanable?
                          </Table.HeaderCell> */}
                          <Table.HeaderCell
                            width={4}
                            className="background-color-FFFFFF font-size-12px"
                            textAlign="center"
                          >
                            Archivo
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            width={2}
                            className="background-color-FFFFFF font-size-12px"
                            textAlign="center"
                          >
                            Acción
                          </Table.HeaderCell>
                        </Table.Header>
                        <Table.Body>
                          {documentacion.map((doc, index) => (
                            <Table.Row
                              key={doc.descripcion_del_documento}
                              className="table-thead-tbody-flex background-color-F5FAFC"
                            >
                              <Table.Cell
                                width={6}
                                className="font-family-Montserrat-Regular font-size-12px font-color-8796A5"
                              >
                                <Icon name="hdd" />
                                {doc.descripcion_del_documento}
                              </Table.Cell>
                              <Table.Cell
                                width={3}
                                className="font-family-Montserrat-Regular font-size-12px font-color-8796A5"
                              >
                                {doc.source === "Persona_Natural"
                                  ? "Persona Natural"
                                  : doc.source === "Persona_Jurídica"
                                    ? "Persona Juridica"
                                    : doc.source === "Grupo_Conformado"
                                      ? "Grupo Conformado"
                                      : null}
                              </Table.Cell>
                              {/* <Table.Cell textAlign="center" width={2}>
                                <Checkbox
                                  checked={doc.subsanable}
                                  onChange={() =>
                                    handlecheckboxChange(doc, "subsanable")
                                  }
                                />
                              </Table.Cell> */}
                              <Table.Cell
                                width={4}
                                className="font-family-Montserrat-Regular font-size-12px font-color-8796A5 justify-content-center"
                              >
                                {doc.url_documento === "" && (
                                  <Button
                                    size="mini"
                                    content="Seleccionar archivo"
                                    className="btn button_archivo"
                                    onClick={() => {
                                      var inputs =
                                        document.getElementsByClassName(
                                          "inputs-ref"
                                        );
                                      inputs[index].click();
                                    }}
                                  />
                                )}
                                {doc.url_documento !== "" && (
                                  <div className="col-12">
                                    <div className="row no-margin archivos-documentos-administrativos width-100">
                                      <div
                                        className="col-12 no-margin"
                                        style={{
                                          paddingLeft: 0,
                                          paddingTop: "5%",
                                        }}
                                      >
                                        <span
                                          className="nombreArchivo"
                                          style={{
                                            display: "block",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {doc.url_documento}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="row no-margin archivos-documentos-administrativos width-100">
                                      <div className="col-12 no-margin justify-content-center width-100">
                                        <span
                                          onClick={() => eliminarArchivo(doc)}
                                          style={{ cursor: "pointer" }}
                                          className="font-size-10px font-color-AD0808 no-margin"
                                        
                                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
                                        >
                                          Eliminar
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <input
                                  className="inputs-ref"
                                  type="file"
                                  hidden
                                  onChange={(e) => cargarUrl(e, doc)}
                                />
                              </Table.Cell>
                              <Table.Cell className="text-center">
                                <div className="row no-margin no-padding-top no-padding-bottom">
                                  <div className="col-6 text-center no-padding-top no-padding-bottom">
                                    <Button
                                      className="botones-acciones"
                                      icon="eye"
                                      onClick={(e) => verDocumentacion(doc)}
                                    />
                                  </div>
                                  <div className="col-6 text-center no-padding-top no-padding-bottom">
                                    <Button
                                      className="botones-acciones boton-borrar-adminconvocatorias"
                                      icon="trash alternate outline"
                                      onClick={(e) =>
                                        eliminarDocumento({ e, doc })
                                      }
                                    />
                                  </div>
                                </div>
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-sticky-footer d-flex justify-content-between align-items-center" style={{ padding: "17px 0" }}>
        <div className="justify-content-flex-start">
          <Button className="button-blanco-radius font-size-12px" onClick={backComponente}>
            Atrás
          </Button>
        </div>
        <div className="justify-content-flex-end">
          <Button
            className="button-azul-radius text-nowrap padding-20"
            onClick={() => guardardocumentacionadministrativa()}
          >
            Guardar y Continuar
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
        </div>
      </div>

      <ModalVisualizarDocumentos
        visualizar={modalVisualizar}
        setVisualizar={setModalVisualizar}
        state={{ documento: principalState.namepdf }}
      />
    </div>
  );
};
